import {
  Component,
  Input,
  ChangeDetectionStrategy,
  OnInit,
  Output,
  EventEmitter,
} from '@angular/core';
import { orderBy } from 'lodash';

import { JumpstoryStatistics } from '../../models';

interface Header {
  title: string;
  prop: string;
  timestamp?: boolean;
  filter?: boolean;
  clickable?: boolean;
  size?: 'big' | 'double' | 'small' | 'half';
}

@Component({
  selector: 'app-jumpstory-statistics-table',
  templateUrl: './jumpstory-statistics-table.component.html',
  styleUrls: ['./jumpstory-statistics-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JumpstoryStatisticsTableComponent implements OnInit {
  private _statistics: JumpstoryStatistics[] = [];
  @Input() set statistics(statistics: JumpstoryStatistics[]) {
    this._statistics = statistics;
    this.filteredStatistics = orderBy(statistics, [this.orderBy], ['desc']);
  }
  get statistics() {
    return this._statistics;
  }

  @Input() sticky: Header = {
    title: 'Account ID',
    prop: 'accountId',
    size: 'half',
    filter: true,
  };
  @Input() orderBy = 'createdAt';
  @Input() extraHeaders: Header[] = [];
  @Input() toggleText: string;
  @Input() header = 'Jumpstory Statistics';
  @Input() showDownloadButton = true;
  @Input() headers: Header[] = [
    { title: 'User ID', prop: 'userId', size: 'small' },
    { title: 'Image ID', prop: 'imageId', size: 'half' },
    { title: 'Image Type', prop: 'imageType', size: 'half' },
    { title: 'Remove Background', prop: 'removeBackground', size: 'half' },
    { title: 'Text Match', prop: 'textMatch', size: 'half' },
  ];

  @Output() rowClick = new EventEmitter<JumpstoryStatistics>();
  @Output() toggleClick = new EventEmitter<boolean>();
  @Output() downloadClick = new EventEmitter();

  filterBy = '';
  filterProps: string[] = [];
  filteredStatistics: JumpstoryStatistics[] = [];
  desc = true;

  ngOnInit() {
    this.filterProps = [this.sticky, ...this.headers, ...this.extraHeaders]
      .filter((header) => header.filter)
      .map((header) => header.prop);
  }

  filter(value: string) {
    this.filterBy = value;
    this.sortAndFilter();
  }

  sort(prop: string) {
    if (this.orderBy === prop) {
      this.desc = !this.desc;
    }
    this.orderBy = prop;
    this.sortAndFilter();
  }

  onRowClick(statistics: JumpstoryStatistics) {
    if (window.getSelection().type !== 'Range') {
      this.rowClick.emit(statistics);
    }
  }

  sortAndFilter() {
    const filter = new RegExp(this.filterBy, 'i');

    this.filteredStatistics = this.statistics.filter((stats) =>
      this.filterProps.some((prop) => filter.test(stats[prop])),
    );

    this.filteredStatistics = orderBy(
      this.filteredStatistics,
      [this.orderBy],
      [this.desc ? 'desc' : 'asc'],
    );
  }
}
